// ACTIONS
export const UPDATE_REFERENCE_SHEET = 'UPDATE_REFERENCE_SHEET';
export const SET_PLAYER = 'SET_PLAYER';
export const SET_IS_REVIEW_PAGE = 'SET_IS_REVIEW_PAGE';
export const SET_SUBMISSION_READY = 'SET_SUBMISSION_READY';
export const SET_IS_ANNOTATION_ENABLED = 'SET_IS_ANNOTATION_ENABLED';
export const SET_IS_SUBMIT_MODAL_VISIBLE = 'SET_IS_SUBMIT_MODAL_VISIBLE';
export const SAVE_PREFERENCE_SUCCESS = 'SAVE_PREFERENCE_SUCCESS';
export const SET_IS_SUBMIT_TIMEOUT_MODAL_VISIBLE =
  'SET_IS_SUBMIT_TIMEOUT_MODAL_VISIBLE';
export const SET_IS_SUBMIT_TIMEOUT_MODAL_VISIBLE_ONCE =
  'SET_IS_SUBMIT_TIMEOUT_MODAL_VISIBLE_ONCE';
export const SET_IS_AUTOSUBMITTED_BY_TIMER = 'SET_IS_AUTOSUBMITTED_BY_TIMER';
export const SET_IS_QUIZ_SUBMITTED = 'SET_IS_QUIZ_SUBMITTED';
export const SET_IS_QUESTION_DISPLAYED = 'SET_IS_QUESTION_DISPLAYED';

export function savePreferenceSuccess(payload) {
  return {
    type: SAVE_PREFERENCE_SUCCESS,
    payload,
  };
}

export const initialState = {
  isApcDataLoading: true,
  isLearnosityApiReady: false,
  isTestReady: false,
  referenceSheet: {},
  isReviewPage: false,
  submissionReady: false,
  isAnnotationEnabled: false,
  isSubmitModalVisble: false,
  isSubmitTimeOutModalVisble: false,
  isSubmitTimeOutModalVisbleOnce: false,
  isAutoSubmittedByTimer: false,
  isQuizSubmitted: false,
  isQuestionDisplayed: false,
};

const bluebookReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_REFERENCE_SHEET:
      return {
        ...state,
        referenceSheet: action.payload,
      };
    case SET_PLAYER:
      return {
        ...state,
        ...action.payload,
      };
    case SET_IS_REVIEW_PAGE:
      return {
        ...state,
        isReviewPage: action.payload,
      };
    case SET_SUBMISSION_READY:
      return {
        ...state,
        submissionReady: action.payload,
      };
    case SET_IS_ANNOTATION_ENABLED:
      return {
        ...state,
        isAnnotationEnabled: action.payload,
      };
    case SET_IS_SUBMIT_MODAL_VISIBLE:
      return {
        ...state,
        isSubmitModalVisble: action.payload,
      };
    case SET_IS_SUBMIT_TIMEOUT_MODAL_VISIBLE:
      return {
        ...state,
        isSubmitTimeOutModalVisble: action.payload,
      };
    case SET_IS_SUBMIT_TIMEOUT_MODAL_VISIBLE_ONCE:
      return {
        ...state,
        isSubmitTimeOutModalVisbleOnce: action.payload,
      };
    case SET_IS_AUTOSUBMITTED_BY_TIMER:
      return {
        ...state,
        isAutoSubmittedByTimer: action.payload,
      };
    case SET_IS_QUIZ_SUBMITTED:
      return {
        ...state,
        isQuizSubmitted: action.payload,
      };
    case SET_IS_QUESTION_DISPLAYED:
      return {
        ...state,
        isQuestionDisplayed: action.payload,
      };
    default:
      return state;
  }
};

export default bluebookReducer;
